import Modal from "src/components/modal/action-modal";
import { CreditVoucher } from "../types/credit-voucher.entity";
import { CreditVoucherDetails } from "./credit-voucher-details";

type CreditVoucherViewButtonProps = { creditVoucher: CreditVoucher };

export const CreditVoucherViewButton = ({ creditVoucher }: CreditVoucherViewButtonProps) => {
  return (
    <Modal buttonText="View Details" size={4}>
      <CreditVoucherDetails creditVoucher={creditVoucher} />
    </Modal>
  );
};
